// extracted by mini-css-extract-plugin
export default {"contact":"ContactSection_contact__hXgFi","contact-light":"ContactSection_contact-light__Zn-fm","contact-dark":"ContactSection_contact-dark__VIY5F"};